import { adminAPIService } from './index'

const route = 'coupons'

export default {
  getList(page = 1, size = 50) {
    const params = { page, size }
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  create(form, featured_image) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(form))
    formData.append('featured_image', featured_image)

    return adminAPIService({
      url: route,
      method: 'post',
      data: formData,
    })
  },
  update(id, form, featured_image) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(form))
    formData.append('featured_image', featured_image)
    
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: formData,
    })
  },
  getCategoryList() {
    return adminAPIService({
      url: `${route}/categories`,
      method: 'get',
    })
  },
}
